import React from 'react';
import { useIntl } from 'react-intl';
import { useT } from '@transifex/react';
import { BankOffersDetailProps } from '../types';
import { BankOffersDetailTabs } from './BankOffersDetailTabs';
import { getDetailConfig } from './config';

export const BankOffersDetail: React.FC<BankOffersDetailProps> = ({ offer }) => {
  const t = useT();
  const { formatNumber, locale, formatDate } = useIntl();
  const { tabs } = getDetailConfig(offer, t, formatNumber, locale, formatDate);

  return <BankOffersDetailTabs tabs={tabs} offer={offer} />;
};

export default BankOffersDetail;
